// src/components/store/sections/newsletter/NewsletterV29VipticketFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV29VipticketFuchsiaGlow(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={29}
      archKey="vip_ticket"
      archLabel="VIP Coupon Ticket Box"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
